export const getCookiesApproval = () => {
  if (typeof window !== "undefined") {
    const cookies_settings =
      JSON.parse(localStorage?.getItem("cookies_settings")) || {};
    if (Object.keys(cookies_settings).length !== 0) {
      const approved = Object.values(cookies_settings).some(
        (value) => value === true
      );
      return approved;
    }
  }
  return null;
};
